<template>
    <div>
        <div class="d-flex justify-space-between mb-2">
            <div class="d-flex justify-center align-center">
                <div class="img_title_bill_retrospect_all">
                    <img src="@/assets/icon-restaurant-bill.png">
                </div>
                <h2 class="title_bill_retrospect_all">รายละเอียดใบกำกับภาษี</h2>
            </div>

            <v-btn class="grad-primary-bg white--text titlefont_bill_retrospect_all" height="50" width="20%"
                @click="$router.push('/billretrospectall')">
                ย้อนกลับ
            </v-btn>
        </div>

        <v-slide-x-reverse-transition>
            <!-- # <v-alert type="success" class="alert_success">ยกเลิกบิลเรียบร้อย</v-alert> -->
        </v-slide-x-reverse-transition>

        <v-card class="mb-5">
            <div v-if="loading_page === true">
                <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                    <v-skeleton-loader type="article, actions"></v-skeleton-loader>
                </v-sheet>
            </div>
            <div v-if="loading_page === false" id="printableArea">
                <v-card-text>
                    <v-row>
                        <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <div style="padding:20px 60px;border:1px solid #1E1E1E">
                                <p v-if="taxDetail.vat_price && taxDetail.vat_price > 0" class="mb-0"
                                    style="text-align:center;font-size:20px;color:#058DC2;font-weight:500">
                                    ใบเสร็จรับเงิน / ใบกำกับภาษี
                                </p>
                                <p v-else class="mb-0"
                                    style="text-align:center;font-size:20px;color:#058DC2;font-weight:500">
                                    ใบเสร็จรับเงิน
                                </p>
                                <p class="mb-0" style="text-align:center;font-size:15px;color:#000000;font-weight:500">
                                    <u>ต้นฉบับ</u>
                                </p>
                            </div>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3"></v-col>
                        <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3" style="display: grid;align-items:center">
                            <p class="mb-0" color="#1E1E1E" style="font-size:15px;font-weight:500;">
                                <span style="color:#058DC2">วันที่ </span>
                                {{ currentDate }}
                                  <!-- {{ taxDetail.created_at }} -->
                            </p>
                            <p class="mb-0" color="#1E1E1E" style="font-size:15px;font-weight:500;">
                                <span style="color:#058DC2">เลขที่ </span>{{ taxDetail.code }}
                            </p>
                        </v-col>
                    </v-row>
                    <!-- ข้อมูลหัวบิลเพิ่มเติม -->
                    <v-row>
                        <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <div>
                                <p class="mb-1" color="#3B3B3B" style="font-size:16px;font-weight:400;">{{
                                    taxDetail.name_bill }}</p>
                                <p class="mb-1" color="#3B3B3B" style="font-size:16px;font-weight:400;">{{
                                    taxDetail.address_bill }}</p>
                                <p class="mb-1" color="#3B3B3B" style="font-size:16px;font-weight:400;">{{
                                    taxDetail.company_address }}</p>
                                <p class="mb-1" color="#3B3B3B" style="font-size:16px;font-weight:400;">
                                    เลขประจำตัวผู้เสียภาษี: {{ taxDetail.tax_number }}</p>
                            </div>
                        </v-col>
                        <v-col v-if="taxDetail.logo_image === 'null'" cols="12" xs="12" sm="12" md="6" lg="6" xl="6"
                            style="text-align: right;padding-right: 155px;">
                            <img :src="image_mockup" alt="logo" style="width:120px;height:120px;">
                        </v-col>
                        <v-col v-else cols="12" xs="12" sm="12" md="6" lg="6" xl="6"
                            style="text-align: right;padding-right: 155px;">
                            <img :src="taxDetail.logo_image" alt="logo" style="width:120px;height:120px;">
                        </v-col>
                    </v-row>

                    <!-- ข้อมูลลูกค้า -->
                    <v-row>
                        <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <p style="color:#058DC2;font-size:16px;font-weight:400;">ลูกค้า&nbsp;<span
                                    style="color:#3B3B3B;">{{ taxDetail.customer_name }}<br>{{ taxDetail.address }} {{
                                        taxDetail.district }} {{ taxDetail.amphoe }} {{ taxDetail.province }} {{
                                        taxDetail.zipcode }}</span></p>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <p style="color:#3B3B3B;font-size:16px;font-weight:400">เลขประจำตัวผู้เสียภาษี: {{
                                taxDetail.tax_number_cus }}</p>
                        </v-col>
                    </v-row>

                    <!-- ตารางรายการอาหารหรืออาหารและเครื่องดื่ม -->
                    <v-row>
                        <v-col cols="12">
                            <v-simple-table>
                                <template v-slot:default>
                                    <thead class="top-invoice-border">
                                        <tr style="color:#3B3B3B;">
                                            <th class="text-center">ลำดับ</th>
                                            <th class="text-center">รายการ</th>
                                            <th class="text-center">จำนวน</th>
                                            <th class="text-center">ราคาต่อหน่วย</th>
                                            <th class="text-center">จำนวนเงิน</th>
                                        </tr>
                                    </thead>
                                    <tbody class="invoice_border invoice_border_last_data">
                                        <!-- เงื่อนไขการแสดงผล -->
                                        <tr v-if="taxDetail.type_show_data === 1">
                                            <td class="text-center">1</td>
                                            <td class="text-center">อาหารและเครื่องดื่ม</td>
                                            <td class="text-center">{{ taxDetail.amount }}</td>
                                            <td class="text-center">{{ formatNumber(taxDetail.price) }}</td>
                                            <td class="text-center">{{ formatNumber(taxDetail.price) }}</td>
                                        </tr>
                                        <template v-else>
                                            <!-- ลูปข้อมูลรายการอาหาร -->
                                            <tr v-for="(item, index) in foodItems" :key="index">
                                                <td class="text-center">{{ index + 1 }}</td>
                                                <td>{{ item.name }}</td>
                                                <td class="text-center">{{ item.amount }}</td>
                                                <td class="text-center">{{ formatNumber(item.price) }}</td>
                                                <td class="text-center">{{ formatNumber(item.total_price) }}</td>
                                            </tr>
                                        </template>
                                    </tbody>
                                    <tfoot class="invoice_border">
                                        <tr v-if="taxDetail.vat_price && taxDetail.vat_price > 0"
                                            style="color:#3B3B3B;">
                                            <td colspan="3" class="text-right"></td>
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:400;color:#3B3B3B;">
                                                    ราคาก่อนภาษี</p>
                                            </td>
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:400;color:#3B3B3B;">
                                                    {{ formatNumber(taxDetail.price) }} </p>
                                            </td>
                                        </tr>
                                        <tr v-else style="color:#3B3B3B;">
                                            <td colspan="3" class="text-right"></td>
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:400;color:#3B3B3B;">
                                                    รวมเงิน</p>
                                            </td>
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:400;color:#3B3B3B;">
                                                    {{ formatNumber(taxDetail.price) }} </p>
                                            </td>
                                        </tr>
                                        <tr v-if="taxDetail.vat_price && taxDetail.vat_price > 0"
                                            style="color:#3B3B3B;">
                                            
                                            <td colspan="3" class="text-left">
                                                <p class="mb-0"
                                                    style="font-size:16px;font-weight:400;color:#058DC2; padding-left:60px">
                                                    การชำระเงิน :
                                                    <span style="color:#3B3B3B;">
                                                        {{ taxDetail.payment_method === 0 ? 'เงินสด' :
                                                            taxDetail.payment_method === 1 ? 'เงินโอน' : 'อื่นๆ'
                                                        }}
                                                    </span>
                                                </p>
                                            </td>
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:400;color:#3B3B3B;">
                                                    vat 7%</p>
                                            </td>
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:400;color:#3B3B3B;">{{
                                                    formatNumber(taxDetail.vat_price)
                                                }}</p>
                                            </td>
                                            
                                        </tr>

                                        <tr v-if="taxDetail.service_charge && taxDetail.service_charge > 0"
                                            style="color:#3B3B3B;">
                                            <td colspan="3" class="text-right"></td>
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:400;color:#3B3B3B;">
                                                    ค่าบริการ
                                                    {{ taxDetail.percen_service_charge }}%</p>
                                            </td>
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:400;color:#3B3B3B;">{{
                                                    formatNumber(taxDetail.service_charge) }}</p>
                                            </td>
                                        </tr>
                                        <tr v-if="taxDetail.vat_price && taxDetail.vat_price > 0"
                                            style="color:#3B3B3B;">
                                            <td colspan="3" class="text-left">
                                                <!-- <p class="mb-0" style="font-size:16px;font-weight:400;color:#058DC2; padding-left:60px">
                                                    การชำระเงิน : 
                                                    <span style="color:#3B3B3B;">
                                                    {{ taxDetail.payment_method === 0 ? 'เงินสด' : taxDetail.payment_method === 1 ? 'เงินโอน' : 'อื่นๆ' }}
                                                    </span>
                                                </p> -->
                                            </td>
                                            <td class="text-center"
                                                style="border-bottom: 1px solid #058DC2 !important;">
                                                <p class="mb-0" style="font-size:16px;font-weight:400;color:#3B3B3B;">
                                                    ราคารวมภาษีมูลค่าเพิ่ม</p>
                                            </td>
                                            <td class="text-center"
                                                style="border-bottom: 1px solid #058DC2 !important;">
                                                <p class="mb-0" style="font-size:16px;font-weight:400;color:#3B3B3B;">
                                                    {{ formatNumber(taxDetail.total_price) }}</p>
                                            </td>
                                        </tr>
                                        <tr v-else style="color:#3B3B3B;">
                                            <td colspan="3" class="text-left">
                                                <!-- <p class="mb-0" style="font-size:16px;font-weight:400;color:#058DC2; padding-left:60px">
                                                    การชำระเงิน : 
                                                    <span style="color:#3B3B3B;">
                                                    {{ taxDetail.payment_method === 0 ? 'เงินสด' : taxDetail.payment_method === 1 ? 'เงินโอน' : 'อื่นๆ' }}
                                                    </span>
                                                </p> -->
                                            </td>
                                            <td class="text-center"
                                                style="border-bottom: 1px solid #058DC2 !important;">
                                                <p class="mb-0" style="font-size:16px;font-weight:400;color:#3B3B3B;">
                                                    จำนวนเงินทั้งสิ้น</p>
                                            </td>
                                            <td class="text-center"
                                                style="border-bottom: 1px solid #058DC2 !important;">
                                                <p class="mb-0" style="font-size:16px;font-weight:400;color:#3B3B3B;">
                                                    {{ formatNumber(taxDetail.price + taxDetail.vat_price) }}</p>
                                            </td>
                                        </tr>
                                        <tr style="color:#3B3B3B;">
                                            <td colspan="3"></td>
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:400;color:#3B3B3B;">
                                                    ส่วนลด</p>
                                            </td>
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:400;color:#3B3B3B;">
                                                    {{ formatNumber(taxDetail.discount) }}</p>
                                            </td>
                                        </tr>
                                        <tr style="color:#3B3B3B;">
                                            <td colspan="3"></td>
                                            <td class="text-center"
                                                style="border-bottom: 2px solid #058DC2 !important;">
                                                <p class="mb-0" style="font-size:16px;font-weight:500;color:#058DC2;">
                                                    ยอดชำระ</p>
                                            </td>
                                            <td class="text-center"
                                                style="border-bottom: 2px solid #058DC2 !important;">
                                                <p class="mb-0" style="font-size:16px;font-weight:500;color:#3B3B3B;">
                                                    {{ formatNumber(taxDetail.reccive_money) }}</p>
                                            </td>
                                        </tr>
                                    </tfoot>
                                </template>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                </v-card-text>
            </div>
        </v-card>
        <v-card>
            <v-card-title style="font-size:20px;color:#000;font-weight:600;">
                ผู้ดำเนินการ
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12" xs="12" sm="12" md="8" lg="8" xl="8">
                        <p style="color:#058DC2;font-size:16px;font-weight:400;">ผู้สร้างใบกำกับภาษี <span
                                style="color:#3B3B3B;">: {{ taxDetail.user_name }}</span>
                        </p>
                        <p style="color:#058DC2;font-size:16px;font-weight:400;">วันที่ <span style="color:#3B3B3B;">:
                                {{ currentDate }} {{ currentTime }}</span>
                        </p>
                    </v-col>
                    <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <p style="color:#058DC2;font-size:16px;font-weight:400; text-align:right">จำนวนการพิมพ์
                            <span style="color:#3B3B3B;">:{{ printCount }} ครั้ง</span>
                        </p>
                        <div style="text-align:right">
                            <v-btn color="success" @click="handlePrint();" height="40">
                                พิมพ์ใบกำกับภาษี
                            </v-btn>
                        </div>

                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import before_image from "@/assets/ZoftConnect_Logo_Black_for_Bill_150px.png";
import { HTTP } from "@/axios.js"; // นำเข้า axios เพื่อใช้ดึงข้อมูลจาก API


export default {
    name: 'billretrospect',
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true, // เริ่มต้น loading ข้อมูล
            taxDetail: {}, // เก็บข้อมูลใบกำกับภาษี
            foodItems: [], // เก็บข้อมูลรายการอาหาร
            image_mockup: before_image,
            currentDate: this.formatDate(new Date()), // ตั้งค่าข้อมูลวันที่ปัจจุบัน
            currentTime: this.formatTime(new Date()),  // สำหรับเวลาปัจจุบัน
            printCount: 0, // เก็บจำนวนครั้งที่พิมพ์
            invoiceId: this.$route.params.id // ใช้ id ของใบกำกับภาษีจาก route
        }
    },
    methods: {
        likePage(page) {
            window.open(page, '_blank');
        },
        async getInvoiceData() {
            try {
                const response = await HTTP.get(`POS/table/invoice-detaile/${this.$route.params.id}`, {
                    headers: {
                        Authorization: `Bearer ${this.$store.state.token}`,
                    },
                });

                if (response.data.successful === true) {
                    this.taxDetail = response.data.invoiceDetaile;
                    this.taxDetail_food = response.data.listnoBuffet;
                    this.foodItems = this.taxDetail_food; // สมมุติว่าข้อมูลรายการอาหารเก็บใน `items`

                    this.loading_page = false; // ปิด loading เมื่อดึงข้อมูลสำเร็จ
                }
            } catch (error) {
                if (error.response.status === 401) {
                    this.$store.commit("logOutSuccess");
                    this.$router.push("/login");
                }
            }
        },
        handlePrint() {
            // ฉันต้องการ new tab ไปยังหน้า BillInvoicePrintDetail

            this.printCount += 1; // เพิ่มจำนวนครั้งที่พิมพ์
            localStorage.setItem(`printCount_${this.invoiceId}`, this.printCount); // เก็บค่าลง localStorage โดยใช้ id
            window.open(`/billinvoiceprintdetail/${this.invoiceId}`, '_blank');
        },
        // printPage() {
        //     const printContents = document.getElementById('printableArea').innerHTML;
        //     const originalContents = document.body.innerHTML;
        //     document.body.innerHTML = printContents;
        //     window.print();
        //     document.body.innerHTML = originalContents;
        //     window.location.reload(); // Reload เพื่อกลับหน้าเดิม
        // },
        formatNumber(value) {
            return new Intl.NumberFormat('th-TH', {
                style: 'currency',
                currency: 'THB',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(value);
        },
        formatDate(dateString) {
            if (!dateString) return "-"; // ถ้าไม่มีค่าส่งกลับ "-"
            
            const date = new Date(dateString); // แปลงเป็น Date object
            const options = { 
                year: 'numeric', 
                month: 'long', 
                day: 'numeric' 
            };
            
            let thaiDate = date.toLocaleDateString('th-TH', options); // แปลงเป็นวันที่แบบไทย
            return thaiDate;
        },
        formatTime(date) {
            const hours = date.getHours().toString().padStart(2, '0');
            const minutes = date.getMinutes().toString().padStart(2, '0');
            const seconds = date.getSeconds().toString().padStart(2, '0');
            return `${hours}:${minutes}:${seconds} น.`; // แสดงผลเวลาปัจจุบัน
        }
    },
    watch: {
        taxDetail: {
            handler(newVal) {
                if (newVal.created_at) {
                    this.currentDate = this.formatDate(new Date(newVal.created_at));
                }
            },
            deep: true
        }
    },
    mounted() {
        this.getInvoiceData(); // เรียก API เมื่อ component โหลดเสร็จ
        // ดึงค่าจำนวนการพิมพ์จาก localStorage ถ้ามีค่า
        const storedCount = localStorage.getItem(`printCount_${this.invoiceId}`);
        if (storedCount) {
            this.printCount = parseInt(storedCount);
        }
    }
}
</script>

<style>
.confirm_invoice_button {
    width: 50% !important;
}

.top-invoice-border>tr>th {
    border-top: 2px solid #058DC2 !important;
    border-bottom: 2px solid #058DC2 !important;
}

.invoice_border>tr>td {
    border: none !important;
}

.invoice_border_last_data>tr:last-child td {
    border-bottom: 2px solid #058DC2 !important;
}

.print_invoice_button {
    background-image: linear-gradient(to bottom, #51BDE7, #058DC2);
    border-radius: 5px;
}

@media screen and (max-width: 768px) {
    .confirm_invoice_button {
        width: 100% !important;
    }
}

/* รูปแบบ A4 สำหรับการปริ้น */
@media print {
    @page {
        size: A4;
        margin: 20mm;
    }

    body {
        font-family: 'TH SarabunPSK', sans-serif;
        /* ปรับรูปแบบฟอนต์สำหรับการปริ้น */
    }

    .invoice_border>tr>td,
    .invoice_border_last_data>tr:last-child td {
        border: none !important;
    }

    .print_invoice_button {
        display: none;
        /* ซ่อนปุ่มพิมพ์เมื่ออยู่ในโหมดพิมพ์ */
    }
}
</style>
